import { useBundle } from "../context/BundleContext";
import { SelectionProvider } from "../context/SelectionContext";
import { CausalSeam } from "../components/seam/CausalSeam";
import { ReplayRail } from "../components/replay/ReplayRail";
import { EmptyState } from "../components/shell/EmptyState";

export function ReplayRoute() {
  const bundle = useBundle();

  return (
    <SelectionProvider>
      <div className="mx-auto max-w-6xl px-6 py-12">
        <h1 className="font-editorial text-3xl text-ink">Differential replay</h1>
        <p className="mt-2 max-w-2xl text-sm text-ink-muted">
          The Causal Seam below is the first point where the vulnerable and patched call trees
          diverge in a way that explains the missing prohibited effect. Select any call in either
          rail to see its aligned counterpart.
        </p>

        <div className="mt-8">
          {bundle.causalSeam ? (
            <CausalSeam seam={bundle.causalSeam} />
          ) : (
            <EmptyState
              title="No alignment or divergence evidence is available for this bundle."
              detail="alignment.json and divergence.json are optional bundle files; this bundle did not ship them."
            />
          )}
        </div>

        <div className="mt-10 flex flex-col gap-8 lg:flex-row">
          <ReplayRail side="vulnerable" title="Vulnerable commit" nodes={bundle.vulnerableRail} />
          <div className="hidden w-px shrink-0 bg-rule lg:block" aria-hidden="true" />
          <ReplayRail side="patched" title="Patched commit" nodes={bundle.patchedRail} />
        </div>
      </div>
    </SelectionProvider>
  );
}
